<script>
  import PostContainer from 'src/pc/components/PostContainer'
  export default {
    extends: PostContainer,
    computed: {
      getAccess () {
        return 'mobile'
      },
    }
  }
</script>

<style>
  .post-container-wrap .post-container {
    display: flex;
    flex-direction: column;
  }
  .post-container-wrap .post-container .img {
    position: absolute;
    right: 0;
    width: 100px;
    height: 80px;
}
  .post-container-wrap .post-container .category {
    font-size: 12px;
    font-weight: 500;
    margin-top: 10px;
    text-transform: uppercase;
    order: 2;
  }
  .post-container-wrap .post-container .subj {
    font-size: 15px;
    font-weight: 700;
    margin-top: 0;
    max-height: 4.0em;
    -webkit-line-clamp: 3;
    order: 1;
  }

  /* gallery modal (Mobile) */
  .q-dialog .gallery_pop .close_btn {
    width: 50px;
    height: 50px;
    top: 5px;
    right: 5px;
  }
  .q-dialog .gallery_pop .album_ctnr .img img {
    max-width: 100vw;
    max-height: 120vh;
  }
  .q-dialog .gallery_pop .album_ctnr .article {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    text-align: left;
    background: linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,1.0) 75%);
    padding: 50px 10px 15px 10px;
    box-sizing: border-box;
  }
  .q-dialog .gallery_pop .album_ctnr .article p {
    width: 80vw;
  }
  .q-dialog .gallery_pop .album_ctnr .article .subj {
    font-size: 16px;
  }
  .q-dialog .gallery_pop .album_ctnr .article .tag a {
    font-size: 13px;
    font-weight: 200;
  }
  .q-dialog .gallery_pop .album_ctnr .article .series {
    font-size: 13px;
  }
  .q-dialog .gallery_pop .album_ctnr .img .img_wrap .download {
    position: fixed;
    right: 10px;
    bottom: 15px;
    margin: 0;
    background-size: 40%;
    z-index: 3;
  }


  /* market modal (Mobile) */
  .close_btn {
    position: absolute;
    top: 15px;
    right: 15px;
    cursor: pointer;
    width: 40px;
    height: 40px;
    z-index: 1;
  }
  .close_btn:before {
    content: "×";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-48%, -54%);
    font-size: 40px;
    font-weight: 300;
    color: #00ff64;
  }
  .close_btn:hover:before {
    color: #fff;
  }
  .insta_ctnr {
    background-color: #fff;
  }
  .insta_ctnr .dark_bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.8);
  }
  .insta_ctnr .close_btn {
    position: absolute;
    top: 15px;
    right: 15px;
    cursor: pointer;
    width: 40px;
    height: 40px;
    z-index: 1;
  }
  .insta_ctnr .close_btn:before {
    content: "×";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-48%, -54%);
    font-size: 40px;
    font-weight: 300;
    color: #00ff64;
  }
  .insta_ctnr .close_btn:hover:before {
    color: #fff;
  }
  .insta_ctnr .logo {
    padding: 12px 20px 12px;
  }
  .insta_ctnr .logo span {
    display: inline-block;
    width: 30px;
    height: 30px;
    background: #000;
    padding: 3px 4px;
    border-radius: 100%;
  }
  .insta_ctnr .logo span img {
    width: 100%;
  }
  .insta_ctnr .logo p {
    display: inline-block;
    font-size: 1.0em;
    font-weight: 900;
    line-height: 30px;
    margin-left: 8px;
  }
  .insta_ctnr .img img {
    max-width: 100%;
    max-height: 100%;
  }
  .insta_ctnr .article {
    padding: 20px 20px 25px 20px;
  }
  .insta_ctnr .article .subj {
    font-size: 1.6em;
    font-weight: 700;
    letter-spacing: -0.01em;
    padding-bottom: 15px;
  }
  .insta_ctnr .article .con {
    font-size: 1.0em;
    font-weight: 400;
    color: #444;
    padding-bottom: 25px;
    line-height: 1.4em;
  }
  .insta_ctnr .article .tag i {
    display: block;
    font-size: 1.0em;
    font-weight: 700;
    padding-bottom: 6px;
  }
  .insta_ctnr .article .tag a {
    display: inline-block;
    margin-right: 6px;
    line-height: 1.6em;
    font-size: 1.0em;
    font-weight: 400;
    color: #379339;
  }
  .insta_ctnr .article .tag a:before {
    content: "#";
  }
  .insta_ctnr .article .tag a:hover {
    color: #000;
  }
  .p_ctnr_inner .date {
    font-size: 13px !important;
  }
  .p_ctnr_inner .date:before {
    font-size: 13px !important;
    padding: 5px 12px !important;
    border-radius: 0.4em !important;
    margin-right: 8px !important;
  }
  .p_ctnr_inner .os_poll {
    margin-bottom: -50px !important;
  }
</style>
